import { Link } from "react-router";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useAuth } from "../auth/AuthContext";

const AUTH_URL = "/api/auth/google";

export const Footer = () => {
  const year = new Date().getFullYear();
  const { authenticated, logout } = useAuth();

  return (
    <Navbar as="footer" variant="light" className="main-footer" role="contentinfo">
      <Container fluid className="footer-inner">
        <span className="footer-copy">The Lil Bougie Foodie ©{year}</span>
        <Nav className="footer-links">
          <Nav.Link as={Link} to="/privacy">Privacy</Nav.Link>
          <Nav.Link as={Link} to="/allergens">Allergens</Nav.Link>
        </Nav>

        <Nav className="footer-actions">
          {!authenticated && (
            <Nav.Link href={AUTH_URL}>Admin login</Nav.Link>
          )}
          {authenticated && (
            <>
              <Nav.Link as={Link} to="/admin">Admin</Nav.Link>
              <button className="nav-link" onClick={logout}>
                Sign out
              </button>
            </>
          )}
        </Nav>
      </Container>
    </Navbar>
  );
};
